import { useAuth } from "@/lib/auth";
import { isPlatformDesignerUser } from "@/lib/usePlatformDesigner";

/** Aviso largo para usuario normal ante error o bloqueo en cola SAT. */
export const SAT_SYNC_SUPPORT_NOTICE =
  "Se detectó un problema en la sincronización SAT. Para evitar movimientos incorrectos en la cola o descargas duplicadas, esta acción debe ser revisada por soporte. Contacte al administrador del despacho.";

/** Variante breve cuando hay retraso o posible bloqueo sin detalle técnico. */
export const SAT_SYNC_SUPPORT_NOTICE_SHORT =
  "Hay una sincronización pendiente o con posible bloqueo. Por seguridad, las acciones de recuperación solo están disponibles para soporte. Contacte al administrador del despacho.";

/**
 * Acciones técnicas del monitor SAT (robot, cola, reintento, reconciliación).
 * Diseñador plataforma o emisor/distribuidor con can_generate_licenses.
 * Pendiente: rol «soporte» dedicado si el backend lo expone en /auth/me.
 */
export function canAccessSatMonitorTechnicalActions(user) {
  if (!user) return false;
  if (isPlatformDesignerUser(user)) return true;
  if (Boolean(user.can_generate_licenses)) return true;
  return false;
}

export function useSatMonitorTechnicalAccess() {
  const { user } = useAuth();
  return canAccessSatMonitorTechnicalActions(user);
}

/** Indica si conviene mostrar aviso de soporte (sin exponer botones técnicos). */
export function hasSatMonitorSyncProblem(syncHealth, items = []) {
  const status = String(syncHealth?.status || "").toLowerCase();
  if (status === "warning" || status === "critical") return true;
  if (syncHealth?.message) return true;
  const rows = Array.isArray(items) ? items : [];
  return rows.some((row) => String(row?.status || "").toUpperCase() === "FAILED");
}
